module.exports = {"id":"209673","name":"Dorian Dessoleil","rating":"72","photo":"./data/images/photos/1/209673.png","club":{"name":"Sp. Charleroi","logo":"./data/images/clubs/Sp.Charleroi.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DorianDessoleil0.json
// module id = 1141
// module chunks = 0